import { render, staticRenderFns } from "./BusinessDataTable.vue?vue&type=template&id=1574dfde&"
import script from "./BusinessDataTable.vue?vue&type=script&lang=js&"
export * from "./BusinessDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports